<dx-validation-group #dxvg>
    <div class="container mt-1" [formGroup]="tripForm">
        <div
            class="row"
            bdsScrollSpySection="tripErrorDetailsAnchor"
            [scrollMargin]="116"
            #tripErrorDetailsAnchor
        >
            <div class="col-12 col-lg-4">
                <h4 class="d-flex flex-row">
                    <span>Import Shipment Validation</span>
                    <span class="flex-fill"></span>
                </h4>
                <div class="row">
                    <div [class.col-5]="!allowChangeKey" [class.col-4]="allowChangeKey">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label> Car Init </mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                [tabindex]="0"
                                [readonly]="true"
                                formControlName="carInit"
                            />
                        </mat-form-field>
                    </div>

                    <div [class.col-7]="!allowChangeKey" [class.col-4]="allowChangeKey">
                        <mat-form-field
                            *ngIf="!allowChangeKey"
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label> Car Number </mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                [readonly]="true"
                                [tabindex]="1"
                                formControlName="carNo"
                            />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex flex-row">
                            <div class="flex-grow-1">
                                <dx-select-box
                                    #consigneeSelectBox
                                    [stylingMode]="dxMatStyle"
                                    [class.bds-mat-dense-form-field]="dense"
                                    [class.dx-mat-form-field-floatLabel-always]="
                                        matFloatLabel === 'always'
                                    "
                                    class="bds-dx-custom-material flex-fill"
                                    formControlName="custNo"
                                    [dataSource]="customerFactDxLookupSource"
                                    fieldTemplate="inputField"
                                    itemTemplate="item"
                                    [valueExpr]="customerFactDxLookupValueExpr"
                                    [searchExpr]="customerFactDxLookupSearchExpr"
                                    [(selectedItem)]="selectedCustomer"
                                    [searchEnabled]="true"
                                    label="Consignee"
                                    (onValueChanged)="onCustomerFactChanged($event)"
                                    validationMessageMode="always"
                                    [required]="!createAsLoadAndHold"
                                >
                                    <dxi-button
                                        name="addConsignee"
                                        [options]="consigneeAddInlineButtonOptions"
                                    ></dxi-button>
                                    <dxi-button
                                        *ngIf="selectedCustomer"
                                        name="editConsignee"
                                        [options]="consigneeEditInlineButtonOptions"
                                    ></dxi-button>
                                    <dxi-button
                                        name="searchConsignee"
                                        [options]="consigneeSearchInlineButtonOptions"
                                    ></dxi-button>
                                    <dxi-button name="dropDown"></dxi-button>
                                    <div *dxTemplate="let data of 'item'">
                                        <span>{{ customerFactDxLookupDisplayExpr(data) }}</span>
                                    </div>
                                    <div *dxTemplate="let data of 'inputField'">
                                        <dx-text-box
                                            bdsShoutcase
                                            style="display: inline-block"
                                            width="100%"
                                            [value]="customerFactDxLookupDisplayExpr(data)"
                                            [label]="
                                                'Consignee' + (!createAsLoadAndHold ? ' *' : '')
                                            "
                                        ></dx-text-box>
                                    </div>
                                </dx-select-box>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Care of Name</mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="
                                    consigneeSelectBox.selectedItem
                                        ? consigneeSelectBox.selectedItem.careOfName
                                        : ''
                                "
                            />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex flex-row">
                            <div class="flex-grow-1">
                                <dx-select-box
                                    #routeCodeSelectBox
                                    [stylingMode]="dxMatStyle"
                                    [class.bds-mat-dense-form-field]="dense"
                                    [class.dx-mat-form-field-floatLabel-always]="
                                        matFloatLabel === 'always'
                                    "
                                    class="bds-dx-custom-material flex-fill"
                                    formControlName="routeCode"
                                    [dataSource]="routeCodeDxLookupSource"
                                    fieldTemplate="inputField"
                                    itemTemplate="item"
                                    [valueExpr]="routeCodeDxLookupValueExpr"
                                    [(selectedItem)]="selectedRoute"
                                    [searchEnabled]="true"
                                    [searchExpr]="routeCodeDxLookupSearchExpr"
                                    label="Route"
                                    validationMessageMode="always"
                                >
                                    <dxi-button
                                        name="addRoute"
                                        [options]="routeAddInlineButtonOptions"
                                    ></dxi-button>
                                    <dxi-button
                                        *ngIf="selectedRoute"
                                        name="editRoute"
                                        [options]="routeEditInlineButtonOptions"
                                    ></dxi-button>
                                    <dxi-button
                                        name="searchRoute"
                                        [options]="routeCodeSearchInlineButtonOptions"
                                    ></dxi-button>
                                    <dxi-button name="dropDown"></dxi-button>
                                    <div *dxTemplate="let data of 'item'">
                                        <span>{{ routeCodeDxLookupDisplayExpr(data) }}</span>
                                    </div>
                                    <div *dxTemplate="let data of 'inputField'">
                                        <dx-text-box
                                            style="display: inline-block"
                                            width="100%"
                                            [value]="routeCodeDxLookupDisplayExpr(data)"
                                            [label]="'Route' + (createAsLoadAndHold ? '' : ' *')"
                                        ></dx-text-box>
                                    </div>
                                    <dx-validator>
                                        <dxi-validation-rule
                                            type="required"
                                            message="Required"
                                        ></dxi-validation-rule>
                                    </dx-validator>
                                </dx-select-box>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                            [class.mat-form-field-disabled]="false"
                        >
                            <mat-label>Diverted </mat-label>
                            <mat-select formControlName="divertYorn">
                                <mat-option></mat-option>
                                <mat-option value="Y">Yes</mat-option>
                                <mat-option value="N">No</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                            [class.mat-form-field-disabled]="false"
                        >
                            <mat-label>Bad Order Days </mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                type="number"
                                formControlName="badOrderDays"
                            />
                            <span matSuffix>days</span>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Freight Payment Code</mat-label>
                            <mat-select formControlName="freightPmtCode">
                                <mat-option></mat-option>
                                <mat-option value="C">COLLECT</mat-option>
                                <mat-option value="F">CUSTOMER - PP</mat-option>
                                <mat-option value="M">MIXED</mat-option>
                                <mat-option value="N">NON-REVENUE</mat-option>
                                <mat-option value="P">PREPAID</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Unit Train ID </mat-label>
                            <input matInput bdsShoutcase formControlName="unitTrainId" />
                            <mat-error *ngIf="tripForm.controls.unitTrainId.errors">
                                {{ getErrorText(tripForm.controls.unitTrainId) }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Trip Ref 1</mat-label>
                            <input matInput bdsShoutcase formControlName="tripRef1" />
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Trip Ref 2</mat-label>
                            <input matInput bdsShoutcase formControlName="tripRef2" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Trip Ref 3</mat-label>
                            <input matInput bdsShoutcase formControlName="tripRef3" />
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Trip Ref 4</mat-label>
                            <input matInput bdsShoutcase formControlName="tripRef4" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>CSR Number </mat-label>
                            <input matInput bdsShoutcase formControlName="csrNo" />
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Import Source</mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                formControlName="importSource"
                            />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Error Description</mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                formControlName="errorDescription"
                            />
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-4">
                <h4 class="d-flex flex-row">
                    <span>&nbsp;</span>
                    <span class="flex-fill"></span>
                </h4>
                <div class="row">
                    <div class="col-12">
                        <bds-date-time-picker
                            formControlName="shipDateTime"
                            label="Shipment Date *"
                        ></bds-date-time-picker>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <dx-select-box
                            [stylingMode]="dxMatStyle"
                            [class.bds-mat-dense-form-field]="dense"
                            [class.dx-mat-form-field-floatLabel-always]="matFloatLabel === 'always'"
                            class="bds-dx-custom-material flex-fill"
                            formControlName="fleetId"
                            [dataSource]="fleetDxLookupSource"
                            fieldTemplate="inputField"
                            itemTemplate="item"
                            valueExpr="fleetId"
                            [searchExpr]="['fleetId', 'fleetName']"
                            [searchEnabled]="true"
                            label="Fleet"
                            validationMessageMode="always"
                        >
                            <dxi-button name="dropDown"></dxi-button>
                            <div *dxTemplate="let data of 'item'">
                                <span>{{ data.fleetId }} - {{ data.fleetName }}</span>
                            </div>
                            <div *dxTemplate="let data of 'inputField'">
                                <dx-text-box
                                    label="Fleet"
                                    style="display: inline-block"
                                    [value]="
                                        data ? kvpDisplayTemplate(data.fleetId, data.fleetName) : ''
                                    "
                                ></dx-text-box>
                            </div>
                        </dx-select-box>
                    </div>
                    <div class="col-6">
                        <dx-select-box
                            [stylingMode]="dxMatStyle"
                            [class.bds-mat-dense-form-field]="dense"
                            [class.dx-mat-form-field-floatLabel-always]="matFloatLabel === 'always'"
                            class="bds-dx-custom-material flex-fill"
                            formControlName="businessGroup"
                            [dataSource]="businessGroupDxLookupSource"
                            fieldTemplate="inputField"
                            itemTemplate="item"
                            valueExpr="businessGroup"
                            [searchEnabled]="true"
                            [searchExpr]="['businessGroup', 'businessGroupName']"
                            label="Business Group"
                        >
                            <dxo-drop-down-options minWidth="250px"></dxo-drop-down-options>
                            <div *dxTemplate="let data of 'item'">
                                <span *ngIf="data; else businessGroupNoItem"
                                    >{{ data.businessGroup }} - {{ data.businessGroupName }}</span
                                >
                                <ng-template #businessGroupNoItem><span></span></ng-template>
                            </div>
                            <div *dxTemplate="let data of 'inputField'">
                                <dx-text-box
                                    label="Business Group"
                                    style="display: inline-block"
                                    [value]="
                                        data
                                            ? kvpDisplayTemplate(
                                                  data.businessGroup,
                                                  data.businessGroupName
                                              )
                                            : ''
                                    "
                                ></dx-text-box>
                            </div>
                        </dx-select-box>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <bds-shipment-type-select
                            formControlName="shipmentType"
                            (selectionChange)="manualUpdate()"
                        ></bds-shipment-type-select>
                    </div>
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                            [class.mat-form-field-disabled]="false"
                        >
                            <mat-label>Shop Move </mat-label>
                            <mat-select formControlName="shopMove">
                                <mat-option></mat-option>
                                <mat-option value="Y">Yes</mat-option>
                                <mat-option value="N">No</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Sales Rep </mat-label>
                            <input matInput bdsShoutcase formControlName="salesRep" />
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                            [class.mat-form-field-disabled]="false"
                        >
                            <mat-label>One Way/RT </mat-label>
                            <mat-select formControlName="oneWayRound">
                                <mat-option></mat-option>
                                <mat-option value="O">One Way</mat-option>
                                <mat-option value="R">Round Trip</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Order Number </mat-label>
                            <input matInput bdsShoutcase formControlName="tripNo" />
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>BOL Number </mat-label>
                            <input matInput bdsShoutcase formControlName="bolNo" />
                            <mat-error *ngIf="tripForm.controls.bolNo.errors">
                                {{ getErrorText(tripForm.controls.bolNo) }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Shipper Number </mat-label>
                            <input matInput bdsShoutcase formControlName="shipperNo" />
                            <mat-error *ngIf="tripForm.controls.shipperNo.errors">
                                {{ getErrorText(tripForm.controls.shipperNo) }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Customer PO Number </mat-label>
                            <input matInput bdsShoutcase formControlName="custPoNo" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Trip Status </mat-label>
                            <!-- (selectionChange)="onTripStatusChange($event)" -->
                            <mat-select formControlName="tripStatus">
                                <mat-option></mat-option>
                                <mat-option value="O">Open</mat-option>
                                <mat-option value="C">Closed</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                            [class.mat-form-field-disabled]="false"
                        >
                            <mat-label>Car Status </mat-label>
                            <mat-select
                                formControlName="carStatus"
                                (selectionChange)="manualUpdate()"
                            >
                                <mat-option></mat-option>
                                <mat-option value="0">0 - At Origin</mat-option>
                                <mat-option value="1">1 - To Consignee</mat-option>
                                <mat-option value="2">2 - At Consignee</mat-option>
                                <mat-option value="3">3 - To Origin</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                            [class.mat-form-field-disabled]="false"
                        >
                            <mat-label>Free Runner </mat-label>
                            <mat-select formControlName="freeRunner">
                                <mat-option></mat-option>
                                <mat-option value="Y">Yes</mat-option>
                                <mat-option value="N">No</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Supplier Shipment</mat-label>
                            <mat-select formControlName="supplierShipment">
                                <mat-option></mat-option>
                                <mat-option value="Y">Yes</mat-option>
                                <mat-option value="N">No</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex flex-row">
                            <div class="flex-grow-1">
                                <dx-select-box
                                    #supplierSelectBox
                                    [stylingMode]="dxMatStyle"
                                    [class.bds-mat-dense-form-field]="dense"
                                    [class.dx-mat-form-field-floatLabel-always]="
                                        matFloatLabel === 'always'
                                    "
                                    class="bds-dx-custom-material flex-fill"
                                    formControlName="supplierCode"
                                    [dataSource]="supplierFactDxLookupSource"
                                    fieldTemplate="inputField"
                                    itemTemplate="item"
                                    [valueExpr]="supplierFactDxLookupValueExpr"
                                    [searchExpr]="supplierFactDxLookupSearchExpr"
                                    [(selectedItem)]="selectedSupplier"
                                    [searchEnabled]="true"
                                    placeholder="Supplier Number (Supplier Code)"
                                    validationMessageMode="always"
                                    (onValueChanged)="onSupplierFactChanged($event)"
                                    [isValid]="tripForm.controls.supplierCode.valid"
                                    label="Supplier"
                                >
                                    <dxi-button
                                        name="searchSupplier"
                                        [options]="supplierSearchInlineButtonOptions"
                                    ></dxi-button>
                                    <dxi-button name="dropDown"></dxi-button>
                                    <div *dxTemplate="let data of 'item'">
                                        <span>{{ supplierFactDxLookupDisplayExpr(data) }}</span>
                                    </div>
                                    <div *dxTemplate="let data of 'inputField'">
                                        <dx-text-box
                                            style="display: inline-block"
                                            width="100%"
                                            [value]="supplierFactInputDxLookupDisplayExpr(data)"
                                            label="Supplier"
                                            [placeholder]="
                                                multipleTrips
                                                    ? ''
                                                    : '(Missing Supplier Code) - ' +
                                                      (tripError?.supplierName || '')
                                            "
                                        ></dx-text-box>
                                    </div>
                                </dx-select-box>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-4">
                <h4 class="d-flex flex-row">
                    <span>Import Details</span>
                    <span class="flex-fill"></span>
                </h4>
                <div class="row">
                    <div class="col-2">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Type </mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError ? tripError?.transactionType : ''"
                            />
                        </mat-form-field>
                    </div>
                    <div class="col-5">
                        <bds-date-time-picker
                            formControlName="entryDate"
                            label="Entry Date Time"
                            [readOnly]="true"
                        ></bds-date-time-picker>
                    </div>
                    <div class="col-5">
                        <bds-date-time-picker
                            formControlName="procDateTime"
                            label="Process Date Time"
                            [readOnly]="true"
                        ></bds-date-time-picker>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Consignee No </mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError ? tripError?.importCustNo : ''"
                            />
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Consignee Name </mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError ? tripError?.importCustName : ''"
                            />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Fleet Id </mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError?.fleetId || ''"
                            />
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Business Group </mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError?.businessGroup || ''"
                            />
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-8">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Route Description</mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError?.importRouteDscr"
                            />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Path Code </mat-label>
                            <input matInput bdsShoutcase readonly tabindex="-1" [value]="" />
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Origin SPLC</mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError?.origSplc ?? ''"
                            />
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Code</mat-label>
                            <input matInput bdsShoutcase readonly tabindex="-1" [value]="" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Origin City</mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError?.origCity"
                            />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Origin State</mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError?.origState"
                            />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Destination SPLC</mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError?.destSplc ?? ''"
                            />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Destination City</mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError?.destCity"
                            />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Destination State</mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError?.destState"
                            />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Orig Road</mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError?.origRoad"
                            />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Dlv Road</mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError?.dlvRoad"
                            />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field
                            floatLabel="always"
                            class="w-100"
                            appearance="fill"
                            [class.highlight-dirty]="highlightDirty"
                            [class.bds-mat-dense-form-field]="dense"
                        >
                            <mat-label>Truck</mat-label>
                            <input
                                matInput
                                bdsShoutcase
                                readonly
                                tabindex="-1"
                                [value]="tripError?.truckDlv"
                            />
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-12" *ngIf="!isLoadingCommodities">
                <h4 class="d-flex flex-row">
                    <span>Commodity Shipped</span>
                    <span class="flex-fill"></span>
                </h4>
                <ng-container *ngFor="let compart of commoditiesShipped; let idx = index">
                    <mat-card class="mb-3">
                        <div class="row">
                            <div class="col-10">
                                <trip-commodity-shipped [commodityShipped]="compart">
                                </trip-commodity-shipped>
                            </div>
                            <!-- <div class="col-2">
                            <button mat-icon-button (click)="onEditProductClick(compart)">
                                <fa-duotone-icon
                                    [icon]="iconEdit"
                                    primaryColor="#005c92"
                                    secondaryColor="#005c92"
                                    [fixedWidth]="true"
                                ></fa-duotone-icon>
                            </button>
                            <button mat-icon-button (click)="onDeleteProductClick(compart.ormId)">
                                <fa-duotone-icon
                                    [icon]="iconDelete"
                                    primaryColor="red"
                                    secondaryColor="red"
                                    [fixedWidth]="true"
                                ></fa-duotone-icon>
                            </button>
                        </div>
                    </div> -->
                        </div>
                    </mat-card>
                </ng-container>
            </div>
        </div>
    </div>
</dx-validation-group>
